import { X } from "lucide-react";
import { motion, AnimatePresence } from "motion/react";
import FilterSidebar from "@/theme1/components/shop/FilterSidebar";

export default function MobileFilterDrawer(props) {
  return (
    <AnimatePresence>
      {props.open && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <motion.button
            type="button"
            aria-label="Close filters"
            onClick={props.onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-black/40"
          />

          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="absolute right-0 top-0 h-full w-[88%] max-w-sm overflow-y-auto bg-white p-5 shadow-2xl"
          >
            <div className="mb-5 flex items-center justify-between">
              <h2 className="text-lg font-semibold">Filters</h2>
              <button
                type="button"
                onClick={props.onClose}
                className="rounded-full border border-border p-2"
              >
                <X className="size-4" />
              </button>
            </div>

            <div className="[&_aside]:block [&_aside>div]:static [&_aside>div]:shadow-none">
              <FilterSidebar {...props} />
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}